/**
 * ACIL Intelligence - Error 404 (Not Found)
 */
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';

export default function Error404() {
  return (
    <div className="error-page" data-testid="error-404-page">
      <Search size={48} color="var(--orange)" style={{ marginBottom: 16 }} />
      <div className="error-code">404</div>
      <div className="error-title">Pagina no encontrada</div>
      <div className="error-text">
        La pagina que buscas no existe o fue movida.
      </div>
      <Link to="/dashboard" className="btn-primary" style={{ textDecoration: 'none' }} data-testid="error-404-home-btn">
        Ir al dashboard
      </Link>
    </div>
  );
}
